import { CreateRouteModal } from './CreateRouteModal';
import { CreateUserModal } from './CreateUserModal';
import styles from './MbapiAdminTopBarRightComponent.module.scss';

export const MbapiAdminTopBarRightComponent = () => {
  return (
    <div className={styles.container}>
      <CreateRouteModal />
      <CreateUserModal />
    </div>
  );
};
